module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sv-f4b3314001ea3a7cf1d0a98c254d8cd3.svg";